import { Box, Typography } from '@mui/material';

import SectionTitle from './SectionTitle';

const contents = [
  'Cung cấp Thông tin',
  'Bạn cần cung cấp thông tin chính xác và đầy đủ về tình trạng y tế hiện tại và bất kỳ bệnh truyền nhiễm nào bạn có thể mắc phải, bao gồm các bệnh trước đây, các lần nhập viện, các loại\nthuốc đang sử dụng, Chỉ dẫn Y tế Tiên tiến (AMD), và các chi tiết liên quan khác để bạn có thể nhận được điều trị y tế phù hợp và an toàn.',
  'Vui lòng thông báo cho chúng tôi nếu bạn có bất kỳ bệnh truyền nhiễm nào hiện có để các biện pháp kiểm soát nhiễm trùng phù hợp có thể được thực hiện. Sức khỏe dài hạn của bạn\nphụ thuộc vào trách nhiệm của bạn trong việc nhận thức tác động của lối sống lên sức khỏe cá nhân của bạn.',
  'Hãy thông báo cho chúng tôi về bất kỳ thay đổi nào trong tình trạng sức khỏe của bạn.',
  'Khi nhận các bản sao báo cáo y tế của mình, vui lòng đảm bảo rằng bạn đã nhận được thông tin chính xác trước khi rời đi.',
];

const contents2 = [
  'Tôn trọng và Sự quan tâm',
  'Chúng tôi mong bạn và các thành viên trong gia đình của bạn có sự quan tâm đến những bệnh nhân khác trong bệnh viện cũng cần nghỉ ngơi và sự chăm sóc của nhân viên; và thể hiện\nsự tôn trọng và lịch sự đối với tất cả nhân viên, bác sĩ và y tá, cũng như các khách thăm.',
  'Bạn chịu trách nhiệm về hành vi của mình và hãy nhận thức rằng việc bạn ở lại bệnh viện; bất kỳ hành vi quấy rối hoặc ý định gây phiền hà cho người khác hoặc gây gián đoạn đến hoạt\nđộng của bệnh viện đều không được chấp nhận.',
  'Vui lòng tuân thủ các quy định của bệnh viện được thiết lập để đảm bảo an toàn cho bệnh nhân.',
  'Vui lòng chú ý đến thiết bị và cơ sở vật chất của bệnh viện, cư xử với tài sản một cách hợp lý và quan tâm giúp chúng tôi giảm thiểu lãng phí tài nguyên quý báu như sử dụng nước và các\ntài nguyên khác.',
];

const contents3 = [
  'Nhập viện',
  'Xin vui lòng không mang theo bất kỳ tài sản quý giá nào với bạn, vì bạn chịu trách nhiệm bảo quản an toàn các tài sản cá nhân của mình.',
  'Xin vui lòng đến nhập viện đúng vào thời gian đã hẹn để đảm bảo rằng các chuẩn bị tiền phẫu thuật cần thiết có thể được hoàn thành một cách an toàn và kiểm soát.',
  'Bạn sẽ được tư vấn về nghĩa vụ tài chính liên quan đến điều trị của bạn bởi các bác sĩ tư vấn cũng như các chi phí phẫu thuật và bệnh viện.',
  'Việc thanh toán hóa đơn hoặc sắp xếp phù hợp để thực hiện các nghĩa vụ tài chính là trách nhiệm của bạn. Bằng cách thanh toán hóa đơn đúng hạn và đầy đủ, bạn sẽ giúp cho bệnh viện\ntiếp tục tập trung vào công việc phục vụ nhu cầu của các bệnh nhân khác.',
];

const contents4 = [
  'Thuốc và Điều trị',
  'Tất cả các loại thuốc của bạn sẽ được cung cấp bởi Nhà thuốc của bệnh viện chúng tôi và được cán bộ y tế thực hiện khi bạn ở trong các bệnh viện của chúng tôi.',
  'Không được động vào bất kỳ thiết bị y tế nào.',
  'Xin vui lòng không mang theo bất kỳ loại thuốc nào từ nhà trừ khi bạn cần cho bác sĩ xem. Tuy nhiên, bạn nên mang theo một danh sách viết tay các loại thuốc mà bạn đang sử dụng và\ncho bác sĩ cũng như y tá tại khu điều trị xem danh sách này. Bất kỳ loại thuốc nào bạn mang từ nhà đến sẽ không được sử dụng và sẽ được trả lại cho bạn để bảo quản.',
];

const PatientsResponsibility = () => {
  return (
    <>
      <SectionTitle title="Trách nghiệm của bệnh nhân" />
      <Box
        sx={{
          width: '98%',
          margin: '48px auto 24px auto',
          border: '1px solid lightgray',
          padding: '10px',
        }}
      >
        {contents.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '15px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          if (i === contents.length - 1) {
            return (
              <Typography
                sx={{
                  fontWeight: '400',
                  fontSize: '15px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '15px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
              }}
            >
              {v}
              <p />
            </Typography>
          );
        })}
      </Box>

      <Box
        sx={{
          width: '98%',
          margin: '48px auto 24px auto',
          border: '1px solid lightgray',
          padding: '10px',
        }}
      >
        {contents2.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '15px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          if (i === contents2.length - 1) {
            return (
              <Typography
                sx={{
                  fontWeight: '400',
                  fontSize: '15px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '15px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
              }}
            >
              {v}
              <p />
            </Typography>
          );
        })}
      </Box>

      <Box
        sx={{
          width: '98%',
          margin: '48px auto 24px auto',
          border: '1px solid lightgray',
          padding: '10px',
        }}
      >
        {contents3.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '15px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          if (i === contents3.length - 1) {
            return (
              <Typography
                sx={{
                  fontWeight: '400',
                  fontSize: '15px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '15px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
              }}
            >
              {v}
              <p />
            </Typography>
          );
        })}
      </Box>

      <Box
        sx={{
          width: '98%',
          margin: '48px auto 24px auto',
          border: '1px solid lightgray',
          padding: '10px',
        }}
      >
        {contents4.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '15px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          if (i === contents4.length - 1) {
            return (
              <Typography
                sx={{
                  fontWeight: '400',
                  fontSize: '15px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '15px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
              }}
            >
              {v}
              <p />
            </Typography>
          );
        })}
      </Box>
    </>
  );
};

export default PatientsResponsibility;
